import React, { Component } from 'react';
import EditProfile from './EditProfile';
import ConfirmDialog from '../Components/ConfirmDialog';

let self;
let t;

class EditProfileContainer extends Component {
    constructor(props) {
        super(props);

        self = this;
        t = props.t;

        this.state = {
            success: null,
            dialogOpen: false,
        }
    }

    openDialog(success) {
        self.setState({
            success: success,
            dialogOpen: true
        });
    }

    closeDialog() {
        self.setState({
            dialogOpen: false
        });
    }

    getDialogTitleText() {
        return t(self.state.success ? 'edit_profile_dialog_success_title' : 'edit_profile_dialog_failure_title');
    }

    getDialogMessageText() {
        return t(self.state.success ? 'edit_profile_dialog_success_message' : 'edit_profile_dialog_failure_message');
    }

    getDialogButtonText() {
        return t('ok');
    }

    onDialogButtonClicked = e => {
        e.preventDefault();
        this.closeDialog();
    }

    render() {
        return (
            <div>
            <EditProfile
                updateAppData={this.props.updateAppData}
                usingValueCode={this.props.usingValueCode}
                t={this.props.t}
                customer={this.props.customer}
                registration_id={this.state.registration_id}
                openDialog={this.openDialog}
                credentials={this.props.credentials}/>
            <ConfirmDialog
                titleText={this.getDialogTitleText()}
                messageText={this.getDialogMessageText()}
                buttonText={this.getDialogButtonText()}
                onButtonClicked={e => this.onDialogButtonClicked(e)}
                open={this.state.dialogOpen}/>
        </div>
        );
    }
}

export default EditProfileContainer;


// WEBPACK FOOTER //
// ./src/Pages/EditProfileContainer.js